module.exports = __webpack_public_path__ + "static/media/patent-screenshot-mobile.420e2d21.png";